import React, { useState, useEffect, useRef } from "react";
import { addcandidate, updateCandidate } from './api/Calls';
import { getNewCondidateList, getCompandy } from '../../../Redux/Actions/newJoinerAction';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;
let token = JSON.parse(localStorage.getItem('key'));

const AddCondidateModel = ({ condidateDetail, setSelelected, setModal }) => {
    const emailRef = useRef();
    const nameRef = useRef();
    const contactRef = useRef();
    const joiningdateRef = useRef();
    const [comp_id, setComp_id] = useState('')
    const [candidatename, setCandidatename] = useState('')
    const [personamemail, setPersonamemail] = useState('')
    const [contact_no, setContact_no] = useState('')
    const [joining_date, setJoining_date] = useState('')



    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.NewJoinerReducer);
    const cancelRef = useRef(null);


    useEffect(() => {
        dispatch(getCompandy());
        setComp_id(condidateDetail?.comp_id ? condidateDetail?.comp_id : '')
        setCandidatename(condidateDetail?.first_name ? condidateDetail?.first_name : '')
        setPersonamemail(condidateDetail?.personal_email ? condidateDetail?.personal_email : '')
        setContact_no(condidateDetail?.contact_no ? condidateDetail?.contact_no : '')
        setJoining_date(condidateDetail?.joining_date ? moment(condidateDetail.joining_date).format('yyyy-MM-DD') : '')

        //setDate(moment(resdata.holiday_date).format('yyyy-MM-DD'))
    }, [condidateDetail, dispatch])





    const handleCancel = () => {
        setSelelected(null);
        // setValues(initialValues);
    };

    var usernameRegex = /^[a-zA-Z0-9]+([a-zA-Z0-9](_|-| )[a-zA-Z0-9])*[a-zA-Z0-9]+$/;
    let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
    let regcontact = /^([+]\d{2}[ ])?\d{10}$/;
    const [errmail, setErrmail] = useState('')
    const [errcomp, setComp] = useState('')
    const [errname, setName] = useState('')
    const [errcontact, setContact] = useState('')
    const [errjoiningdate, setJoiningdate] = useState('')
    const handleSubmit = () => {
        setErrmail('');
        setComp('')
        setName('')
        setContact('')
        setJoiningdate('');

        if (comp_id === "") {
            setComp('red')
            return false
        }
        if (!usernameRegex.test(candidatename)) {
            setName('red')
            nameRef.current.focus();
            return false
        }
        if (!regEmail.test(personamemail)) {
            setErrmail('red');
            emailRef.current.focus();
            return false
        } if (!regcontact.test(contact_no)) {
            setContact('red')
            contactRef.current.focus();
            return false;
        }
        if (joining_date == '') {
            setJoiningdate('red')
            joiningdateRef.current.focus()
            return false;
        }
        else {
            const response = fetch(SERVER_URL + `api/common/checkemail?email=${personamemail}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                }).then(res => res.json())
                .then(data => {
                    // console.log(data)
                    if (data.result.total > 0) {

                        setErrMSGEmailverify('email already registered');
                        // setBtnerr('disabled')
                        return false;
                    } else {
                        setErrMSGEmailverify('');
                        setBtnerr('')

                        addcandidate({ comp_id: comp_id, first_name: candidatename, personal_email: personamemail, contact_no: contact_no, joining_date: joining_date }).then((res) => {
                            if (res.status) {
                                setComp_id('')
                                setCandidatename('')
                                setPersonamemail('')
                                setContact_no('')
                                setJoining_date('')
                                cancelRef.current.click();
                                setModal(false)
                                dispatch(getNewCondidateList())
                                return alert(res.msg)
                                setSelelected(null);

                            } else {
                                return alert(res.msg)
                            }
                        })
                    }
                })



        }
    }
    const handelUpdate = () => {

        setErrmail('');
        setComp('')
        setName('')
        setContact('')
        setJoiningdate('');

        if (comp_id === "") {
            setComp('red')
            return false
        }
        if (!usernameRegex.test(candidatename)) {
            setName('red')
            nameRef.current.focus();
            return false
        }
        if (!regEmail.test(personamemail)) {
            setErrmail('red');
            emailRef.current.focus();
            return false
        } if (!regcontact.test(contact_no)) {
            setContact('red')
            contactRef.current.focus();
            return false;
        }
        if (joining_date == '') {
            setJoiningdate('red')
            joiningdateRef.current.focus()
            return false;
        }
        else {
            const updatedData = {
                comp_id: comp_id,
                first_name: candidatename,
                personal_email: personamemail,
                contact_no: contact_no,
                joining_date: joining_date
            }
            updateCandidate(condidateDetail.condidateID, updatedData).then((res) => {
                if (res.status) {
                    //setValues(initialValues)
                    cancelRef.current.click();
                    dispatch(getNewCondidateList())
                    return alert(res.msg)
                } else {
                    return alert(res.msg)
                }
            })
        }
    }
    const [errMSGEmailverify, setErrMSGEmailverify] = useState('')
    const [btnerr, setBtnerr] = useState('')
    const handleEmail = (e) => {
        setPersonamemail(e.target.value)
        setErrMSGEmailverify('')
    }
    return (
        <>
            <div className="modal fade" id="addcandidate" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="decorative-shape shape-1"></div>
                            <div className="decorative-shape shape-2"></div>
                            <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close" ref={cancelRef} onClick={handleCancel}>
                                <i className="icon icon-cross fw-bold" />
                            </button>
                            <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{condidateDetail ? 'Update' : 'Add'} Candidate</div>

                            <div className="mb-2">
                                <label className="col-form-label">Company Name <sup className="error_mgs">*</sup></label>
                                <select style={{ 'borderColor': errcomp }} className="form-select" onChange={e => { setComp_id(e.target.value) }} id="comp_id" name="comp_id" value={comp_id}>
                                    <option value="">--Select Company Name--</option>
                                    {company?.map((item, key) => {
                                        return (
                                            <option key={key} value={item.id}>{item.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="mb-2">
                                <label className="col-form-label">Candidate Name <sup className="error_mgs">*</sup></label>
                                <input ref={nameRef} style={{ 'borderColor': errname }} type="text" className="form-control" onChange={e => { setCandidatename(e.target.value) }} id="first_name" name="first_name" value={candidatename} />
                            </div>
                            <div className="mb-2">
                                <label className="col-form-label">Personal Email <sup className="error_mgs">* {errMSGEmailverify}</sup></label>
                                <input disabled={condidateDetail?true:false} ref={emailRef} style={{ 'borderColor': errmail }} type="text" className="form-control" onChange={handleEmail} id="personal_email" name="personal_email" value={personamemail} />
                            </div>
                            <div className="mb-2">
                                <label className="col-form-label">Contact Number <sup className="error_mgs">*</sup></label>
                                <input ref={contactRef} style={{ 'borderColor': errcontact }} type="text" className="form-control" maxLength={10} onChange={e => { setContact_no(e.target.value) }} id="contact_no" name="contact_no" value={contact_no} />
                            </div>
                            <div className="mb-3">
                                <label className="col-form-label">Date of Joining <sup className="error_mgs">*</sup></label>
                                <input ref={joiningdateRef} style={{ 'borderColor': errjoiningdate }} type="date" className="form-control" onChange={e => { setJoining_date(e.target.value) }} id="joining_date" name="joining_date" value={joining_date} />
                            </div>
                            <div className="modalfooter">
                                <div className="row">
                                    <div className="col-md-6 pr07">
                                      <button disabled={btnerr} type="button" className="btn_5 w-100" onClick={condidateDetail ? handelUpdate : handleSubmit}>{condidateDetail ? 'Update' : 'Add'}</button>
                                    </div>
                                    <div className="col-md-6 pl07"> 
                                        <button type="button" className="btn_6 w-100" data-bs-dismiss="modal" ref={cancelRef} onClick={handleCancel}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default AddCondidateModel;